<div class="card card-statistics mb-30">
  <div class="card-body">
      <h5 class="card-title" *ngIf="inner_DeviceBehfa.id==0">Create Repair Request</h5>
      <h5 class="card-title" *ngIf="inner_DeviceBehfa.id!=0">Repair Information 'Code {{inner_DeviceBehfa.id}}'</h5>



      <form >

        <button *ngIf="canEditMainForm && inner_DeviceBehfa.id==0" type="button" (click)="openModal_DeviceBehfa(templateDeviceBehfa)" class="btn btn-danger left"> Select Behfa Equipment <i class="fa fa-building"></i> </button>

        <div  *ngIf="Data_Seleted_DeviceBehfa_Record.id>0">

          <div class="row">
            <div class="form-group col-md-3">
              <label for="exampleInputEmail1">Description</label>
              <input disabled type="text" class="form-control" value="{{Data_Seleted_DeviceBehfa_Record.description}}" >
            </div>
            <div class="form-group col-md-3">
              <label for="exampleInputEmail1">Manufacturer</label>
              <input disabled type="text" class="form-control" value="{{Data_Seleted_DeviceBehfa_Record.manufacturer}}" >
            </div>
            <div class="form-group col-md-3">
              <label for="exampleInputEmail1">model</label>
              <input disabled type="text" class="form-control" value="{{Data_Seleted_DeviceBehfa_Record.model}}" >
            </div>
            <div class="form-group col-md-3">
              <label for="exampleInputEmail1">Code BEHFA</label>
              <input disabled type="text" class="form-control" value="{{Data_Seleted_DeviceBehfa_Record.codeBEHFA}}" >
            </div>
          </div>

          <br/>
          <hr/>
          <br/>

          <div class="row" >
            <div class="form-group col-md-12">
              <label for="exampleInputEmail1">Description </label>
              <textarea  type="text" [disabled]="!canEditMainForm" name="UserDsc" [(ngModel)]="UserDsc" class="form-control" placeholder="Type here..." ></textarea>
            </div>

          </div>

          <br/>
          <hr/>
          <br/>

          <div class="row" *ngIf="canEditMainForm">
            <div class="form-group col-md-12">
              <label for="exampleInputEmail1"> Primary Reviewer </label>
              <select [(ngModel)]="Selected_FirstUser" name="Selected_FirstUser" class="custom-select">
                <option value="0">Select</option>
                <option *ngFor="let item of DataList_FirstUser" [value]="item.id">{{item.title}}</option>
              </select>
            </div>

          </div>

          <br/>
          <hr/>
          <br/>

          <div *ngIf="canEditMainForm" class="row">
            <div class="form-group col-md-6">
              <label for="exampleInputEmail1">
                 Attachments
                <button (click)="Remove_uploadImage1()"  type="button" *ngIf="UploadImageSrc"  class="btn  btn-danger" ><i class="fa  fa-times-rectangle"></i> </button>
              </label>
              <img *ngIf="InProccessing_Image1" src="assets/Loading.gif" style="width: 25px;" />
              <input *ngIf="!InProccessing_Image1" #file_Image1 (change)="uploadImage1(file_Image1.files)" type="file" class="form-control"  placeholder="Type here...">
            </div>
          </div>

          <button  type="button" (click)="Add_uploadImage1()" [disabled]="!UploadImageSrc" class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Add Attachment </button>

          <br/>

          <div class="table-responsive" *ngIf="UploadImageSrc_List.length>0">
            <table class="mb-0 table table-bordered table-3 text-center table-striped">
              <thead style="background-color: #489b39; color: white;">
                <tr>
                  <th>#</th>
                  <th>File</th>

                  <th *ngIf="canEditMainForm" >Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of UploadImageSrc_List" >

                    <td>{{UploadImageSrc_List.indexOf(item)+1}}</td>
                    <td>
                      <img *ngIf="!item.includes('.pdf')" (click)="openModal(templateImage,item)" style="width: 150px;cursor: zoom-in;" src="{{BaseUrl}}File/DeviceBehfaRepair/{{item}}"/>
                    </td>
                    <td *ngIf="canEditMainForm">
                        <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                          <div class="btn-group" role="group">
                              <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                  Actions
                              </button>
                              <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                                  <a style="cursor: pointer;" (click)="UploadImageSrc_List_Delete(UploadImageSrc_List.indexOf(item))" class="dropdown-item" ><i class="fa fa-remove"></i> Delete </a>
                              </div>
                          </div>
                      </div>
                    </td>

                </tr>
              </tbody>
            </table>
          </div>


          <div *ngIf="inner_DeviceBehfa.id>0" >

            <br/>
            <hr/>
            <br/>

            <div class="row" >
              <div class="form-group col-md-9">
                <label for="exampleInputEmail1"> Initial Review Description </label>
                <textarea  type="text" [disabled]="!canAnswerFirst" name="UserDscFirst" [(ngModel)]="UserDscFirst" class="form-control" placeholder="Type here..." ></textarea>
              </div>

              <div class="form-group col-md-3">
                <label for="exampleInputEmail1"> Initial Review Date and User </label>
                <input disabled type="text" class="form-control" value="{{UserDateTimeFirst}} - {{UserUserNameFirst}}" >
              </div>
            </div>

          </div>

          <div *ngIf="inner_DeviceBehfa.id>0 && UserUserNameFirst && first_Answer!=false" >

            <br/>
            <hr/>
            <br/>

            <div class="row" >
              <div class="form-group col-md-6">
                <label for="exampleInputEmail1"> Secondary Review Description </label>
                <textarea  type="text" [disabled]="!canAnswerSecond" name="UserDscSecond" [(ngModel)]="UserDscSecond" class="form-control" placeholder="Type here..." ></textarea>
              </div>

              <div class="form-group col-md-3" *ngIf="canAnswerSecond">
                <label for="exampleInputEmail1">Contractor </label>
                <select class="custom-select" (change)="ReadData_Contractor_Cusetomer()" [(ngModel)]="Selected_Contractor.id" name="Selected_Contractor" >
                  <option value="0">Select</option>
                  <option *ngFor="let item of DataList_Contractor" [value]="item.id">{{item.title}}</option>
                </select>
              </div>

              <div class="form-group col-md-3" *ngIf="canAnswerSecond">
                <label for="exampleInputEmail1">Customer</label>
                <select class="custom-select" [(ngModel)]="Selected_Contractor_Customer.id" name="Selected_Contractor_Customer" >
                  <option value="0">Select</option>
                  <option *ngFor="let item of DataList_Contractor_Customer" [value]="item.id">{{item.title}}</option>
                </select>
              </div>

              <div class="form-group col-md-3" *ngIf="!canAnswerSecond">
                <label for="exampleInputEmail1">Contractor </label>
                <input disabled type="text" class="form-control" value="{{Selected_Contractor.title}} - {{Selected_Contractor_Customer.title}}" >
              </div>

              <div class="form-group col-md-3">
                <label for="exampleInputEmail1"> Secondary Review Date </label>
                <input disabled type="text" class="form-control" value="{{UserDateTimeSecond}}  - {{UserUserNameSecond}}" >
              </div>
            </div>

          </div>


          <div *ngIf="inner_DeviceBehfa.id>0 && UserUserNameSecond && second_answer!=false" >

            <br/>
            <hr/>
            <br/>

            <div class="row" >
              <div class="form-group col-md-4">
                <label for="exampleInputEmail1"> Contact Number </label>
                <input  type="text" [disabled]="!canAnswerThird" class="form-control" placeholder="Type here..." [(ngModel)]="third_phone" name="third_phone" >
              </div>

              <div class="form-group col-md-4" *ngIf="canAnswerThird" >
                <label for="exampleInputEmail1"> Expense </label>
                <input  type="number" class="form-control" placeholder="Type here..."  [(ngModel)]="third_price2" name="third_price2" >
              </div>
              <div class="form-group col-md-4" *ngIf="!canAnswerThird" >
                <label for="exampleInputEmail1"> Expense </label>
                <input disabled type="text" class="form-control" value="{{third_price}}" >
              </div>

              <div class="form-group col-md-4" *ngIf="canAnswerThird">
                <label for="exampleInputEmail1">Unit</label>
                <select class="custom-select" [(ngModel)]="Selected_Money.id" name="Selected_MoneyId" >
                  <option value="0">Select</option>
                  <option *ngFor="let item of DataList_Money" [value]="item.id">{{item.title}}</option>
                </select>
              </div>

              <div class="form-group col-md-4" *ngIf="!canAnswerThird">
                <label for="exampleInputEmail1">Unit</label>
                <input disabled type="text" class="form-control" value="{{Selected_Money.title}}" >
              </div>

            </div>

            <div class="row" >
              <div class="form-group col-md-12">
                <label for="exampleInputEmail1"> Services and Recommendations Provided by Repairer  </label>
                <textarea  type="text" [disabled]="!canAnswerThird" name="third_dsc" [(ngModel)]="third_dsc" class="form-control" placeholder="Type here..." ></textarea>
              </div>
            </div>

            <div class="row" *ngIf="canAnswerThird" >
              <div class="form-group col-md-12">
                <label for="exampleInputEmail1"> Status Equipment  </label>
                <select class="custom-select" [(ngModel)]="third_device_id" name="third_device_id" >
                  <option value="0">Select</option>
                  <option value="1">Active</option>
                  <option value="2">Inactive</option>
                  <option value="4">Under Calibration</option>
                  <option value="5">Permanently Inactive</option>
                </select>
              </div>
            </div>

          </div>

          <br/>
          <hr/>
          <br/>


        </div>

      </form>

      <br/>
      <br/>

      <button *ngIf="!InProccessing && canEditMainForm && Data_Seleted_DeviceBehfa_Record.id>0" (click)="onSubmit()" type="button"  class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Save </button>
      <br/>
      <br/>

      <button *ngIf="!InProccessing && canAnswerFirst" (click)="PostAnswerFirst(1)" type="button"  class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Approve Initial Review </button>
      <button *ngIf="!InProccessing && canAnswerFirst" (click)="PostAnswerFirst(0)" type="button"  class="btn btn-danger" style="margin-right: 5px;"><i class="fa  fa-times-rectangle"></i> Reject Initial Review </button>


      <button *ngIf="!InProccessing && canAnswerSecond && UserUserNameFirst" (click)="PostAnswerSecond(1)" type="button"  class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Approve Secondary Review </button>
      <button *ngIf="!InProccessing && canAnswerSecond && UserUserNameFirst" (click)="PostAnswerSecond(0)" type="button"  class="btn btn-danger" style="margin-right: 5px;"><i class="fa  fa-times-rectangle"></i> Reject Secondary Review </button>

      <button *ngIf="!InProccessing && canAnswerThird && UserUserNameSecond" (click)="PostAnswerThird()" type="button"  class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Back Instrument </button>


      <br/>
      <br/>

      <button (click)="OnSet_DeviceBehfaRepair()" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> Back </button>

  </div>
</div>


<ng-template #templateDeviceBehfa>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Behfa Equipment List </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_DeviceBehfa.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> Keyword </label>
          <input type="text" class="form-control" (keyup)="ReadData_DeviceBehfa_KeySearch()"
            [(ngModel)]="Search_Code_DeviceBehfa_Table" placeholder="Type here to search...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>System ID</th>
              <th>Description</th>
              <th>Manufacturer</th>
              <th>Model</th>
              <th>Code BEHFA</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_DeviceBehfa
            | paginate
                    : {
                        id: 'DataList_DeviceBehfa',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: (DataList_DeviceBehfa).length
                      }">
              <td>{{DataList_DeviceBehfa.indexOf(item)+1}}</td>
              <td>{{item.code}}</td>
              <td class="EnglishClm">{{item.description}}</td>
              <td class="EnglishClm">{{item.manufacturer}}</td>
              <td class="EnglishClm">{{item.model}}</td>
              <td class="EnglishClm">{{item.codeBEHFA}}</td>
              <td (click)="Set_Selected_DeviceBehfa_Record(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> Select</button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="Procssing_DeviceBehfa" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!Procssing_DeviceBehfa" type="button" (click)="ReadData_DeviceBehfa()" class="btn btn-info"
      style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_DeviceBehfa.hide()">Close</button>
  </div>
</ng-template>


<ng-template #templateImage>
  <div class="modal-header">
     <h4 class="modal-title pull-left"> View Image </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Image.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-body" style="text-align: center;">
    <img  style="max-width: 350px;" src="{{BaseUrl}}File/DeviceBehfaRepair/{{ModalimageUrl}}"/>
  </div>
  <div class="modal-footer">
    <a class="dropdown-item" target="_blank" href="{{BaseUrl}}File/DeviceBehfaRepair/{{ModalimageUrl}}"   ><i class="fa fa-download"></i> Download </a>
     <button type="button" class="btn btn-danger" (click)="modalRef_Image.hide()">Close</button>
  </div>
</ng-template>
